const moduleSelectedServiceNode = {
    namespaced: true,
    state: {
        loading: false,
        selectedServiceNode: {},
    },
    getters: {
        getSelectedServiceNode(state) {
            return state.selectedServiceNode;
        },
        getLoading(state) {
            return state.loading;
        },
    },
    mutations: {
        setSelectedServiceNode(state, selectedServiceNode) {
            state.selectedServiceNode = selectedServiceNode;
        },
        setLoading(state, loading) {
            state.loading = loading;
        },
    },
};
export default moduleSelectedServiceNode;
